import { useTranslation } from "react-i18next";
import AdminDashboardItem from "../../../types/admin/dashboard/AdminDashboardItem";
import AdminDashboardCard from "./AdminDashboardCard";

interface AdminDashboardTileGridProps {
  items: AdminDashboardItem[];
  headingId?: string;
}

const AdminDashboardTileGrid = ({ items, headingId }: AdminDashboardTileGridProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
      role={headingId ? "group" : undefined}
      aria-labelledby={headingId}
    >
      {items.map((item) => (
        <AdminDashboardCard
          key={item.id}
          title={t(item.titleKey, item.title)}
          description={t(item.descriptionKey, item.description)}
          icon={item.icon}
          to={item.to}
        />
      ))}
    </div>
  );
};

export default AdminDashboardTileGrid;
